import React, { useState, useRef, useEffect } from "react";
import { LoadScriptNext, Autocomplete } from "@react-google-maps/api";
import { useDispatch, useSelector } from "react-redux"; // To connect Redux
import { registerUser } from "../redux/actions/authActions"; // Import the register action
import { toast } from "react-toastify";
const libraries = ["places"];

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    firm_name: "",
    mobile: "",
    email: "",
    password: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    lat: "",
    long: "",
  });

  const [mapReady, setMapReady] = useState(false);
  const autocompleteRef = useRef(null);

  const handlePlaceChanged = () => {
    const place = autocompleteRef.current?.getPlace();

    if (place) {
      let address = "";
      let city = "";
      let state = "";
      let pincode = "";
      let lat = "";
      let long = "";

      // Extract the formatted address, city, state, pincode, lat, and long from the place object
      place.address_components.forEach((component) => {
        const types = component.types;
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          state = component.long_name;
        }
        if (types.includes("postal_code")) {
          pincode = component.long_name;
        }
      });

      if (place.geometry && place.geometry.location) {
        lat = place.geometry.location.lat();
        long = place.geometry.location.lng();
      }

      address = place.formatted_address;

      // Update the formData state with the extracted values
      setFormData((prev) => ({
        ...prev,
        address,
        city,
        state,
        pincode,
        lat,
        long,
      }));
    }
  };
  const dispatch = useDispatch();
  const { loading, userInfo, error } = useSelector((state) => state.auth);
  useEffect(() => {
    if (userInfo) {
      toast.success("Registration successful!");
    }
    if (error) {
      toast.error(error.message || "Registration failed");
    }
  }, [userInfo, error]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Call the registerUser action
    dispatch(registerUser(formData));
  };

  return (
    <LoadScriptNext
      googleMapsApiKey="AIzaSyBjwQjSQoYFe5OzJxbhnodl-usXAt6AH8g"
      libraries={libraries}
      onLoad={() => setMapReady(true)}
    >
      {mapReady ? (
        <div className="my-10 flex justify-center items-center min-h-screen bg-primary">
          <form
            onSubmit={handleSubmit}
            className="bg-white p-8 rounded-lg shadow-md w-full max-w-md"
          >
            <h2 className="text-2xl font-bold text-center mb-6 text-gray-700">
              Create Account
            </h2>

            {/* Name */}
            <div className="relative mb-6">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                placeholder=" "
                required
              />
              <label
                htmlFor="name"
                className="absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                  peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                  peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
              >
                Name
              </label>
            </div>

            {/* Firm Name */}
            <div className="relative mb-6">
              <input
                type="text"
                name="firm_name"
                value={formData.firm_name}
                onChange={handleChange}
                className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                placeholder=" "
                required
              />
              <label
                htmlFor="firm_name"
                className="absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                  peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                  peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
              >
                Firm Name
              </label>
            </div>

            {/* Mobile */}
            <div className="relative mb-6">
              <input
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                placeholder=" "
                required
              />
              <label
                htmlFor="mobile"
                className="absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                  peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                  peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
              >
                Mobile
              </label>
            </div>

            {/* Email */}
            <div className="relative mb-6">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                placeholder=" "
                required
              />
              <label
                htmlFor="email"
                className="absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                  peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                  peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
              >
                Email
              </label>
            </div>

            {/* Password */}
            <div className="relative mb-6">
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                placeholder=" "
                required
              />
              <label
                htmlFor="password"
                className="absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                  peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                  peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
              >
                Password
              </label>
            </div>

            {/* Address Autocomplete */}
            <div className="relative mb-6">
              <Autocomplete
                onLoad={(ref) => (autocompleteRef.current = ref)}
                onPlaceChanged={handlePlaceChanged}
              >
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Start typing address..."
                  className="peer w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-sm focus:outline-none focus:border-blue-500"
                />
              </Autocomplete>
              <label
                htmlFor="address"
                className="absolute left-2.5 -top-2 text-xs bg-white px-1 transition-all duration-200 text-gray-500
                  peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-400
                  peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-500"
              >
                Address
              </label>
            </div>

            {/* Hidden Fields for city, state, pincode, lat, long */}
            <input type="hidden" name="city" value={formData.city} />
            <input type="hidden" name="state" value={formData.state} />
            <input type="hidden" name="pincode" value={formData.pincode} />
            <input type="hidden" name="lat" value={formData.lat} />
            <input type="hidden" name="long" value={formData.long} />

            <button
              type="submit"
              className="w-full py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              Submit
            </button>

            <div className="mt-4 text-center">
              <p className="text-sm">
                Already have an account?{" "}
                <a href="/login" className="text-blue-500 hover:underline">
                  Login here
                </a>
              </p>
            </div>
          </form>
        </div>
      ) : (
        <div className="flex justify-center items-center min-h-screen">
          <p className="text-gray-500 text-lg">Loading Google Maps...</p>
        </div>
      )}
    </LoadScriptNext>
  );
};

export default Register;
